var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectJoinList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "list"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.5 9.99935L7.5 9.99935M17.5 4.99935L7.5 4.99935M17.5 14.9993L7.5 14.9993M4.16667 9.99935C4.16667 10.4596 3.79357 10.8327 3.33333 10.8327C2.8731 10.8327 2.5 10.4596 2.5 9.99935C2.5 9.53911 2.8731 9.16602 3.33333 9.16602C3.79357 9.16602 4.16667 9.53911 4.16667 9.99935ZM4.16667 4.99935C4.16667 5.45959 3.79357 5.83268 3.33333 5.83268C2.8731 5.83268 2.5 5.45959 2.5 4.99935C2.5 4.53911 2.8731 4.16602 3.33333 4.16602C3.79357 4.16602 4.16667 4.53911 4.16667 4.99935ZM4.16667 14.9993C4.16667 15.4596 3.79357 15.8327 3.33333 15.8327C2.8731 15.8327 2.5 15.4596 2.5 14.9993C2.5 14.5391 2.8731 14.166 3.33333 14.166C3.79357 14.166 4.16667 14.5391 4.16667 14.9993Z",
    stroke: "#5C595C",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectJoinList);
export default __webpack_public_path__ + "static/media/project-join-list.ed7b1d6ed105cfcda77103efd57fb335.svg";
export { ForwardRef as ReactComponent };